import URL, { Address } from 'url-parse';

import { parseSearch } from './query';

export const parse = (url: Address) =>
  new URL(url, location, parseSearch);
